import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import Asset from './Asset';
import camelCase from '../../utils/strings/camelCase';
import css from './Layouts.module.scss';
import Heading from './Heading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var proptypes = {
  block: PropTypes.shape().isRequired,
  lazyload: PropTypes.bool.isRequired,
  removeOuterMargins: PropTypes.bool.isRequired
};
export var ImageBottomTextTop = function ImageBottomTextTop(_ref) {
  var block = _ref.block,
      lazyload = _ref.lazyload,
      removeOuterMargins = _ref.removeOuterMargins;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, css.imageBottomTextTop, _defineProperty({}, css.removeOuterMargins, removeOuterMargins)]),
    children: [/*#__PURE__*/_jsx(Heading, _objectSpread({}, block)), /*#__PURE__*/_jsx(Asset, _objectSpread(_objectSpread({}, block), {}, {
      lazyload: lazyload
    }))]
  });
};
ImageBottomTextTop.propTypes = proptypes;
export var ImageCenterTextCenter = function ImageCenterTextCenter(_ref3) {
  var block = _ref3.block,
      lazyload = _ref3.lazyload,
      removeOuterMargins = _ref3.removeOuterMargins;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, css.imageCenterTextCenter, css[camelCase(block.layout)], _defineProperty({}, css.removeOuterMargins, removeOuterMargins)]),
    children: [/*#__PURE__*/_jsx(Asset, _objectSpread(_objectSpread({}, block), {}, {
      lazyload: lazyload
    })), /*#__PURE__*/_jsx(Heading, _objectSpread({}, block))]
  });
};
ImageCenterTextCenter.propTypes = proptypes;
export var ImageCenterTextOverlayLeft = function ImageCenterTextOverlayLeft(_ref5) {
  var block = _ref5.block,
      lazyload = _ref5.lazyload,
      removeOuterMargins = _ref5.removeOuterMargins;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, css[camelCase(block.layout)], _defineProperty({}, css.removeOuterMargins, removeOuterMargins)]),
    children: [/*#__PURE__*/_jsx(Asset, _objectSpread(_objectSpread({}, block), {}, {
      lazyload: lazyload
    })), /*#__PURE__*/_jsx(Heading, _objectSpread(_objectSpread({}, block), {}, {
      overlayLeft: true
    }))]
  });
};
ImageCenterTextOverlayLeft.propTypes = proptypes;
export var ImageLeftTextRight = function ImageLeftTextRight(_ref7) {
  var block = _ref7.block,
      lazyload = _ref7.lazyload,
      removeOuterMargins = _ref7.removeOuterMargins;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, css.imageLeftTextRight, _defineProperty({}, css.removeOuterMargins, removeOuterMargins)]),
    children: [/*#__PURE__*/_jsx(Asset, _objectSpread(_objectSpread({}, block), {}, {
      lazyload: lazyload
    })), /*#__PURE__*/_jsx(Heading, _objectSpread({}, block))]
  });
};
ImageLeftTextRight.propTypes = proptypes;
export var ImageRightTextLeft = function ImageRightTextLeft(_ref9) {
  var block = _ref9.block,
      lazyload = _ref9.lazyload,
      removeOuterMargins = _ref9.removeOuterMargins;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, css.imageRightTextLeft, _defineProperty({}, css.removeOuterMargins, removeOuterMargins)]),
    children: [/*#__PURE__*/_jsx(Heading, _objectSpread({}, block)), /*#__PURE__*/_jsx(Asset, _objectSpread(_objectSpread({}, block), {}, {
      lazyload: lazyload
    }))]
  });
};
ImageRightTextLeft.propTypes = proptypes;
export var ImageTopTextBottom = function ImageTopTextBottom(_ref11) {
  var block = _ref11.block,
      lazyload = _ref11.lazyload,
      removeOuterMargins = _ref11.removeOuterMargins;
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, css.imageTopTextBottom, _defineProperty({}, css.removeOuterMargins, removeOuterMargins)]),
    children: [/*#__PURE__*/_jsx(Asset, _objectSpread(_objectSpread({}, block), {}, {
      lazyload: lazyload
    })), /*#__PURE__*/_jsx(Heading, _objectSpread({}, block))]
  });
};
ImageTopTextBottom.propTypes = proptypes;